import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import UseAxios from '../../../Api/http/http';
import { getLostDroppedReport } from '../../../Api/request/misReports';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

export function useLostDroppedReport(initialDateRange) {
  const [lostDroppedRows, setLostDroppedRows] = useState([]);
  const [lostDroppedData, setLostDroppedData] = useState(null);
  const [lostDroppedPageSize, setLostDroppedPageSize] = useState(20);
  const [lostDroppedDateRange, setLostDroppedDateRange] = useState({
    startDate: initialDateRange.startDate,
    endDate: initialDateRange.endDate,
    label: initialDateRange.label,
  });

  const getLostDroppedData = async (startDate, endDate, dealType) => {
    try {
      const formattedStartDate = startDate ? format(startDate, 'yyyy-MM-dd') : '';
      const formattedEndDate = endDate ? format(endDate, 'yyyy-MM-dd') : '';

      const response = await UseAxios(getLostDroppedReport(formattedStartDate, formattedEndDate, dealType));

      setLostDroppedData(response?.data?.data);
      const values = response.data?.data?.lostDroppedDetails.map((detail) => ({
        ...detail,
        id: uuidv4(),
      })) || [];

      setLostDroppedRows(values);
      setLostDroppedPageSize(values.length + 1 || 20);
    } catch (error) {
      console.error('Error fetching Lost/Dropped positions:', error);
      setLostDroppedRows([]);
      setLostDroppedPageSize(20);
    }
  };

  return {
    lostDroppedRows,
    lostDroppedData,
    lostDroppedPageSize,
    lostDroppedDateRange,
    setLostDroppedDateRange,
    getLostDroppedData,
  };
}

useLostDroppedReport.propTypes = {
  initialDateRange: PropTypes.shape({
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    label: PropTypes.string,
  }),
};
